/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Blog_Ai_Single_Locale_HintInputs */

const cs_blog_ai_single_locale_hint = /** @type {(inputs: Blog_Ai_Single_Locale_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generování a vylepšení mění pouze verzi ${i?.locale}. Pro ostatní jazyky použijte překlad níže.`)
};

const en_blog_ai_single_locale_hint = /** @type {(inputs: Blog_Ai_Single_Locale_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generate and polish only update the ${i?.locale} version. Use translation below for other languages.`)
};

/**
* | output |
* | --- |
* | "Generate and polish only update the {locale} version. Use translation below for other languages." |
*
* @param {Blog_Ai_Single_Locale_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_single_locale_hint = /** @type {((inputs: Blog_Ai_Single_Locale_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Single_Locale_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_single_locale_hint(inputs)
	return cs_blog_ai_single_locale_hint(inputs)
});